import gql from "graphql-tag";

export default gql`
  query CvmMaterialFacts(
    $deliveryDateStart: Date!
    $deliveryDateEnd: Date!
    $limit: Int
    $cursor: Cursor
    $filterByIssuerCnpj: String
    $filterByIssuers: CvmMaterialFactIssuersFilter
    $filterByCategories: [String!]
  ) {
    cvmMaterialFacts(
      deliveryDateStart: $deliveryDateStart
      deliveryDateEnd: $deliveryDateEnd
      limit: $limit
      cursor: $cursor
      filterByIssuerCnpj: $filterByIssuerCnpj
      filterByIssuers: $filterByIssuers
      filterByCategories: $filterByCategories
    ) {
      nodes {
        sequentialId
        protocol
        category
        type
        kind
        subjects
        dateOfReference
        deliveryDate
        url
        downloadUrl
        investorRelationsContact {
          name
          email
          phone
        }
        issuer {
          ...BrazilianCompanyIssuerHoverCardFields
        }
      }
      totalCount
      pageInfo {
        cursor
        hasNextPage
      }
    }
  }
  fragment BrazilianCompanyIssuerHoverCardFields on BrazilianCompanyIssuer {
    _id
    name
    tickerSymbolPrefix
    businessDescription
    isBrazilianDepositaryReceipt
    sector
    niceLogo {
      url
    }
    marketCapitalization {
      asOfDate
      totalCapitalization
    }
  }
`;
